<cst-card>
  <ng-template cstCardContent>
    <frm-text
      #berichtText
      label="Bericht"
      [formControl]="berichtTextCtl"
      [multiline]="true"
      [rows]="6"
    ></frm-text>
    <p-fileupload
      #uploader
      mode="advanced"
      chooseIcon="fa fa-plus"
      accept="image/*"
      maxFileSize="1000000"
      [customUpload]="true"
      (onSelect)="onSelect($event)"
      [multiple]="true"
      chooseLabel="Upload Image"
      i18n-chooseLabel="@FormularEditorBerichteUploadImage"
    >
      <ng-template
        pTemplate="header"
        let-files
        let-chooseCallback="chooseCallback"
      >
        <cst-toolbar>
          <ctrl-btn-create (click)="chooseCallback()"></ctrl-btn-create>
        </cst-toolbar>
      </ng-template>
      <ng-template #file> </ng-template>
      <ng-template #empty>
        <div class="flex items-center justify-center flex-col">
          <i
            class="pi pi-cloud-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color"
          ></i>
          <p class="mt-6 mb-0">Drag and drop files to here to upload.</p>
        </div>
      </ng-template>
    </p-fileupload>
    <bericht-image-gallery
      [images]="berichtImages()"
      (delete)="deleteImage($event)"
    ></bericht-image-gallery>
  </ng-template>
</cst-card>
